//////////////////////////////
// デバイス判定
var getDevice = (function(){
	var ua = navigator.userAgent;
	if(ua.indexOf('iPhone') > -1 || ua.indexOf('iPod') > -1 || ua.indexOf('Android') > -1 && ua.indexOf('Mobile') > -1){
		return 'sp';
	}else if(ua.indexOf('iPad') > -1 || (ua.indexOf('Macintosh') > -1 && 'ontouchend' in document) || ua.indexOf('Android') > -1){
		return 'tab';
	}else{
		return 'pc';
	}
})();

//////////////////////////////
// ブラウザ判定
var getBrowser = (function(){

	var result = 'unknown';
	var agent = navigator.userAgent.toLowerCase();

	if(agent.indexOf('msie') > -1 || agent.indexOf('trident/7') > -1){
		result = 'ie';
	}else if(agent.indexOf('edge') > -1){
		result = 'edge';
	}else if (agent.indexOf('chrome') > -1){
		result = 'chrome';
	}else if (agent.indexOf('safari') > -1){
		result = 'safari';
	}else if (agent.indexOf('opera') > -1){
		result = 'opera';
	}else if (agent.indexOf('firefox') > -1){
		result = 'firefox';
	}

	return result;
})();


// クリックイベント設定
var isTouchDevice = (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
var _click = (isTouchDevice) ? 'touchend' : 'click';


(function(){

	var flg_total_init = 0;

	// DOMロード完了
	$(function(){
		flg_total_init++;
		totalInitialize();

		initialize();
		$(window).on('scroll touchmove', onScroll);
		$(window).on('resize', onResize);
	});

	$(window).on('load', onLoad);

	// 全ロード完了
	function onLoad(){
		flg_total_init++;
		totalInitialize();
	}

	function onScroll(){
		scrollSwitch();
		setFloatingbtn();
		setFloatingObject01();
		setFloatingObject02();
	}

	function onResize(){
		scrollSwitch();
		setFloatingbtn();
		setFloatingObject01();
		setFloatingObject02();

		setTimeout(function(){
			ScrollTrigger.refresh();
			
			console.log('refresh');
		}, 500);
	}


	//////////////////////////////////////
	// 初期処理（DOM load完了）
	function initialize(){
		//window.scrollTo(0,0);	// 初期スクロール

		setIeAlert();
		setupXxCode();
		setSmoothScroll();
		setOpenSnsWindow();
		setLineShareUrl();
		delClass4NoPc();
		scrollSwitchInit();
		setDragScroll();

	}


	//////////////////////////////////////
	// 最終初期処理（全load完了）
	function totalInitialize(){
		if(flg_total_init < 2) return;

		//$('html, body').animate({scrollTop:0}, '1');	// 初期スクロール

		setFloatingbtn();
		setFloatingObject01();
		setFloatingObject02();
		scrollTriggerGimic01();
		setSliders();

		setTimeout(function(){
			$('body').addClass('scroll-ok');
			scrollSwitch();
			ScrollTrigger.refresh();
		}, 500);

	}


	//////////////////////////////////////
	// IEアラート
	function setIeAlert(){
		if(getBrowser == 'ie'){
			alert('お使いのブラウザは閲覧推奨環境ではありません。\nウェブサイトが正しく表示されない、動作しない等の現象が起こる場合がありますので予めご了承ください。\nchromeまたはEdgeブラウザのご利用をおすすめいたします。');
		}
	}


	//////////////////////////////////////
	// スマホ・タブレットに不要class削除
	function delClass4NoPc(){
		if(getDevice != 'pc'){
			$('.hover').removeClass('hover');
			$('.hover01').removeClass('hover01');
			$('.open-window-sns').removeClass('open-window-sns');
		}
	}


	//////////////////////////////////////
	// スムーズスクロール
	function setSmoothScroll(){
		var speed = 500;

		$('body').on(_click, 'a[href^="#"]', function(){
			var href= $(this).attr('href');
			var target = $(href == '#' || href == '' ? 'html' : href);
			var pos = target.offset().top;
			$('html, body').animate({scrollTop:pos}, speed, 'swing');
			return false;
		});

	}


	//////////////////////////////////////
	// SNSウィンドオープン
	function setOpenSnsWindow(){
		$('body').on(_click, '.open-window-sns', function(){
			var h = 450;
			var w = 600;
			var t = window.screenTop + (window.innerHeight / 2) - (h / 2);
			var l = window.screenLeft + (window.innerWidth / 2) - (w / 2);

			var href = $(this).attr('href');
			window.open(href, 'post-sns', 'width='+w+',height='+h+',top='+t+',left='+l+',menubar=no,toolbar=no,scrollbars=yes');
			return false;
		});
	}


	//////////////////////////////////////
	// LINEシェアURL変更処理
	function setLineShareUrl(){
		if(getDevice != 'sp'){
			$('.js-line-url01').each(function(){
				var url = $(this).attr('href');
				url = url.replace('https://line.me/R/msg/text/?', 'https://social-plugins.line.me/lineit/share?text=');
				$(this).attr('href', url);
			});
		}
	}


	//////////////////////////////////////
	// 追従ボタン制御
	function setFloatingbtn(){
		var st = $(window).scrollTop();
		var wh = window.innerHeight;
		var lm1 = $('.area01').offset().top;
		var lm2 = $('#access').offset().top;

		if((lm1 - wh) < st && st <= (lm2 - wh)){
			//$('.floating-btn01').addClass('appeared');
			$('.floating-btn01').fadeIn(500);
		}else{
			//$('.floating-btn01').removeClass('appeared');
			$('.floating-btn01').fadeOut(500);
		}
	}


	//////////////////////////////////////
	// スクロールスイッチ
	function scrollSwitchInit(){
		$('.js-effect').each(function(){
			var tg = $(this);

			if(tg.hasClass('e00')){
				gsap.set(tg, {opacity:0});
			}
			if(tg.hasClass('e01')){
				gsap.set(tg, {opacity:0});
			}
			/*if(tg.hasClass('e02')){
				gsap.set(tg, {opacity:0, y:'110%'});
			}
			if(tg.hasClass('e03')){
				gsap.set(tg, {opacity:1, scale:0.2});
			}*/

		});
	}

	function scrollSwitch(){
		if(!$('body').hasClass('scroll-ok')) return;

		var st = $(window).scrollTop();
		var wh = $(window).height();
		var oy = st + (wh * 0.7);

		$('.js-effect').each(function(){
			var tg = $(this);
			if(!tg.hasClass('e-end')){

				var tt = tg.offset().top;

				if((oy - wh) < tt && tt < oy){

					// フェードイン
					if(tg.hasClass('e00')){
						tg.addClass('e-end');
						gsap.to(tg, {duration: 0.8, opacity:1, ease:Power1.easeIn});
					}

					// フェードイン2
					if(tg.hasClass('e01')){
						tg.addClass('e-end');
						gsap.to(tg, {duration: 0.5, opacity:1, ease:Power1.easeIn});
					}

					/*// 上入り
					if(tg.hasClass('e02')){
						tg.addClass('e-end');
						gsap.to(tg, {duration: 0.8, opacity:1, y:'0%', ease:Power4.easeOut});
					}

					// 拡大
					if(tg.hasClass('e03')){
						tg.addClass('e-end');
						gsap.to(tg, {duration: 0.6, scale:1, ease:Power1.easeOut});
					}*/

					// e-area01
					if(tg.hasClass('e-area01')){
						tg.addClass('e-end');
						setAnimeArea01();
					}

					// e-area02
					if(tg.hasClass('e-area02')){
						tg.addClass('e-end');
						setAnimeArea02();
					}

					// e-area03
					if(tg.hasClass('e-area03')){
						tg.addClass('e-end');
						setAnimeArea03();
					}

					// e-area04
					if(tg.hasClass('e-area04')){
						tg.addClass('e-end');
						setAnimeArea04();
					}

					// e-area05
					if(tg.hasClass('e-area05')){
						tg.addClass('e-end');
						setAnimeArea05();
					}

					// e-area06
					if(tg.hasClass('e-area06')){
						tg.addClass('e-end');
						setAnimeArea06();
					}

					// e-area07
					if(tg.hasClass('e-area07')){
						tg.addClass('e-end');
						setAnimeArea07();
					}

				}
			}
		});

	}


	//////////////////////////////////////
	// e-area01アニメ
	function setAnimeArea01(){
		var tg = '.e-area01';
		var tm = 0;

		gsap.to(tg+'__parts01_01', {duration: 0.8, opacity:1, ease: Power1.easeIn, delay: tm+0});
		gsap.to(tg+'__parts02_01', {duration: 0.8, opacity:1, ease: Power1.easeIn, delay: tm+0});

		gsap.to(tg+'__parts03', {duration: 0.8, opacity:1, ease: Power1.easeIn, delay: tm+0});
		gsap.to(tg+'__parts04', {duration: 0.8, opacity:1, ease: Power1.easeIn, delay: tm+0});
		gsap.to(tg+'__parts05', {duration: 0.8, opacity:1, ease: Power1.easeIn, delay: tm+0});

		var du = 0.6;
		var de = du * (70 / 700);

		gsap.to(tg+'__parts06', {duration: du+de, left: '100%', ease: Linear.easeNone, delay: tm+2.4});
		gsap.to(tg+'__parts07', {duration: du+de, right: '100%', ease: Linear.easeNone, delay: tm+2.4});

		gsapMp.wipeRight(tg+'__parts01_02>div', du, tm+2.4+(de/2), Linear.easeNone);
		gsapMp.wipeLeft(tg+'__parts02_02>div', du, tm+2.4+(de/2), Linear.easeNone);

	}


	//////////////////////////////////////
	// e-area02アニメ
	function setAnimeArea02(){
		var tg = '.e-area02';
		var tm = 0;

		a_area02_motion();

		gsap.to(tg+'__parts01', {duration: 0.8, opacity:1, ease:Power1.easeIn, delay: tm+1.5});
		gsap.to(tg+'__parts02', {duration: 0.8, opacity:1, ease:Power1.easeIn, delay: tm+1.5});
		gsap.to(tg+'__parts03', {duration: 0.8, opacity:1, ease:Power1.easeIn, delay: tm+1.5});
		gsap.to(tg+'__parts04', {duration: 0.8, opacity:1, ease:Power1.easeIn, delay: tm+1.5});

	}


	function a_area02_motion(){
		var dataset = [77, 20, 3];
		var color = ['#0050AA','#65A8DF','#B0B0B0'];
		var pie = d3.pie()
			.sort(null);

		var svg = d3.select('svg.js-piechart01')
			.append('g')
			.attr('transform', 'translate(130,130)');

		var path = svg.selectAll('path')
			.data(pie(dataset))
			.enter()
			.append('path')
			.attr('fill', function(d, i) {
				return color[i];
			})
			.attr('d', function(d, i) {
				d._tmp = d.endAngle;
				d.endAngle = d.startAngle;
				d.arc = d3.arc().innerRadius(0).outerRadius(130);
				return d.arc(d);
			})
			.transition()
			.delay(function(d, i) {
				return i * 500;
			})
			.duration(500)
			.attrTween('d', function(d, i) {
				var intp = d3.interpolate(d.startAngle, d._tmp);
				return function(t) {
					d.endAngle = intp(t);
					return d.arc(d);
				}
			});
	}



	//////////////////////////////////////
	// e-area03アニメ
	function setAnimeArea03(){
		var tg = '.e-area03';
		var tm = 0;

		// グラフ動作
		var graph_data = [36.7, 26.7, 12, 9.1, 5.3, 5.3, 2.7, 1.2, 1];

		var cal_speed = function(num){
			return num / 100 * 3;
		};

		gsap.set(tg+'__parts01>div', {transformOrigin: 'top left'});

		for(var cnt = 0; cnt < graph_data.length; cnt++){
			var s = cal_speed(graph_data[cnt]);

			gsap.fromTo($(tg+'__parts01>div').eq(cnt), {opacity:0}, {duration: 0.2, opacity:1, delay: tm+0});
			gsap.fromTo($(tg+'__parts01>div').eq(cnt), {scaleX: '0%'}, {duration: s, scaleX: '100%', ease: Linear.easeNone, delay: tm+0});
			gsap.fromTo($(tg+'__parts02').eq(cnt), {opacity:0}, {opacity:1, delay: tm+0.2+s});
		}
	}


	//////////////////////////////////////
	// e-area04アニメ
	function setAnimeArea04(){
		//var tg = '.e-area04';
		//var tm = 0;

		swiper01.params.autoplay = {delay: 5000};
		swiper01.autoplay.start();
		//swiper01.slideNext();
	}


	//////////////////////////////////////
	// e-area05アニメ
	function setAnimeArea05(){
		var tg = '.e-area05';
		var tm = 0;

		gsap.to(tg+'__parts01', {duration: 0.8, opacity:1, ease:Power1.easeIn, delay: tm+0});
	}


	//////////////////////////////////////
	// e-area06アニメ
	function setAnimeArea06(){
		var tg = '.e-area06';
		var tm = 0;
		var idx = 0;

		for(var cnt = 0; cnt < 6; cnt++){
			setTimeout(function(){
				var st = $(tg+'__parts01').scrollTop();
				var ah = $(tg+'__parts01').height();
				var ot = $(tg+'__parts01>div>div').eq(idx).offset().top - $(tg+'__parts01').offset().top + st;
				var oh = $(tg+'__parts01>div>div').eq(idx).height();
				var mb = parseInt($(tg+'__parts01>div>div').eq(idx).css('margin-bottom'), 10);

				if((ot + oh + mb) > (st + ah)){
					var pos = (ot + oh + mb) - ah;
					$(tg+'__parts01').animate({scrollTop: pos}, 80, 'swing');
				}
				$(tg+'__parts01>div>div').eq(idx).addClass('current');

				//console.log(' st:'+st+' ah:'+ah+' ot:'+ot+' oh:'+oh);
				//console.log(' st+ah:'+(st+ah)+' ot+oh:'+(ot+oh)+' pos:'+(ot + oh - ah));
				//console.log(' mb:'+mb);

				idx++;
			}, (1000 * cnt) + tm);
		}

	}


	//////////////////////////////////////
	// e-area07アニメ
	function setAnimeArea07(){
		var tg = '.e-area07';
		var tm = 0;
		var idx = 0;

		for(var cnt = 0; cnt < 6; cnt++){
			setTimeout(function(){
				var st = $(tg+'__parts01').scrollTop();
				var ah = $(tg+'__parts01').height();
				var ot = $(tg+'__parts01>div>div').eq(idx).offset().top - $(tg+'__parts01').offset().top + st;
				var oh = $(tg+'__parts01>div>div').eq(idx).height();
				var mb = parseInt($(tg+'__parts01>div>div').eq(idx).css('margin-bottom'), 10);

				if((ot + oh + mb) > (st + ah)){
					var pos = (ot + oh + mb) - ah;
					$(tg+'__parts01').animate({scrollTop: pos}, 80, 'swing');
				}
				$(tg+'__parts01>div>div').eq(idx).addClass('current');

				idx++;
			}, (1000 * cnt) + tm);
		}

	}


	//////////////////////////////////////
	// スクロールトリガーギミック１
	function scrollTriggerGimic01(){

		gsap.registerPlugin(ScrollTrigger);


		// 横スライダー
		ScrollTrigger.matchMedia({
			"(max-width: 599px)": function(){
				var w = ((620 * 4) + (65 * 3));
				var p = -((w - 620) / w) * 100;

				// 横スライダー1（私はこうして乗り切った）
				gsap.to('.js-scroll-target01', {
					xPercent: p,
					ease: Linear.easeNone,

					scrollTrigger: {
						trigger: '.js-scroll-wrap01',
						start: "top top",
						end: "+=1000",
						pin: true,
						scrub: true,

						onUpdate: function(self){
							var i = calcPagenationIndex(620, 65, self.progress);
							$('.js-scroll-target01__dot01>span').removeClass('current');
							$('.js-scroll-target01__dot01>span').eq(i).addClass('current');
						},
					}
				});

				// 横スライダー2（周囲の助けをきかっけに）
				gsap.to('.js-scroll-target02', {
					xPercent: p,
					ease: Linear.easeNone,

					scrollTrigger: {
						trigger: '.js-scroll-wrap02',
						start: "top top",
						end: "+=1000",
						pin: true,
						scrub: true,

						onUpdate: function(self){
							var i = calcPagenationIndex(620, 65, self.progress);
							$('.js-scroll-target02__dot01>span').removeClass('current');
							$('.js-scroll-target02__dot01>span').eq(i).addClass('current');
						},
					}
				});


				// スマホスクロール1（本人ができること）
				/*gsap.fromTo('.js-scroll-target03',
					{
						yPercent: 80,
					},
					{
						yPercent: 0,
						ease: Linear.easeNone,

						scrollTrigger: {
							trigger: '.js-scroll-wrap03',
							start: "top top",
							end: "+=1000",
							pin: true,
							scrub: true,

							onUpdate: function(self){
								var i = Math.ceil(self.progress * 7) - 1;
								i = i < 0 ? 0 : i;
								$('.js-scroll-target03>div:not(:eq(0))').removeClass('current');
								$('.js-scroll-target03>div:nth-child(-n+'+(i+1)+')').addClass('current');
							},
						}
					}
				);*/


				// スマホスクロール2（親はどうすれば）
				/*gsap.fromTo('.js-scroll-target04',
					{
						yPercent: 80,
					},
					{
						yPercent: 0,
						ease: Linear.easeNone,

						scrollTrigger: {
							trigger: '.js-scroll-wrap04',
							start: "top top",
							end: "+=1000",
							pin: true,
							scrub: true,

							onUpdate: function(self){
								var i = Math.ceil(self.progress * 7) - 1;
								i = i < 0 ? 0 : i;
								$('.js-scroll-target04>div:not(:eq(0))').removeClass('current');
								$('.js-scroll-target04>div:nth-child(-n+'+(i+1)+')').addClass('current');
							},
						}
					}
				);*/


				// グラフ（「いじめ」を検索した前後で検索しているワードは？）
				/*ScrollTrigger.create({
					trigger: '.js-scroll-wrap05',
					start: "top top",
					end: "+=1000",
					pin: true,
					scrub: true,

					onUpdate: function(self){
						var i = Math.ceil(self.progress * 4) - 1;
						i = i < 0 ? 0 : i;
						$('.js-scroll-target05__graph01>div').removeClass('current');
						$('.js-scroll-target05__graph01>div').eq(i).addClass('current');

						$('.js-scroll-target05__text01>ul>li').removeClass('current');
						$('.js-scroll-target05__text01>ul>li').eq(i).addClass('current');
					},
				});*/


			},
			"(min-width: 600px)": function(){
				//var w = ((470 * 4) + (20 * 3));
				//var p = -((w - 470) / w) * 100;
				var w = ((352 * 4) + (15 * 3));
				var p = -((w - 352) / w) * 100;

				// 横スライダー1（私はこうして乗り切った）
				gsap.to('.js-scroll-target01', {
					xPercent: p,
					ease: Linear.easeNone,

					scrollTrigger: {
						trigger: '.js-scroll-wrap01',
						start: "top top",
						end: "+=1000",
						pin: true,
						scrub: true,

						onUpdate: function(self){
							var i = calcPagenationIndex(352, 15, self.progress);
							$('.js-scroll-target01__dot01>span').removeClass('current');
							$('.js-scroll-target01__dot01>span').eq(i).addClass('current');
						},
					}
				});

				// 横スライダー2（周囲の助けをきかっけに）
				gsap.to('.js-scroll-target02', {
					xPercent: p,
					ease: Linear.easeNone,

					scrollTrigger: {
						trigger: '.js-scroll-wrap02',
						start: "top top",
						end: "+=1000",
						pin: true,
						scrub: true,

						onUpdate: function(self){
							var i = calcPagenationIndex(352, 15, self.progress);
							$('.js-scroll-target02__dot01>span').removeClass('current');
							$('.js-scroll-target02__dot01>span').eq(i).addClass('current');
						},
					}
				});


				// スマホスクロール1（本人ができること）
				/*gsap.fromTo('.js-scroll-target03',
					{
						yPercent: 80,
					},
					{
						yPercent: 0,
						ease: Linear.easeNone,

						scrollTrigger: {
							trigger: '.js-scroll-wrap03',
							start: "top top",
							end: "+=1000",
							pin: true,
							scrub: true,

							onUpdate: function(self){
								var i = Math.ceil(self.progress * 7) - 1;
								i = i < 0 ? 0 : i;
								$('.js-scroll-target03>div:not(:eq(0))').removeClass('current');
								$('.js-scroll-target03>div:nth-child(-n+'+(i+1)+')').addClass('current');
							},
						}
					}
				);*/


				// スマホスクロール2（親はどうすれば）
				/*gsap.fromTo('.js-scroll-target04',
					{
						yPercent: 80,
					},
					{
						yPercent: 0,
						ease: Linear.easeNone,

						scrollTrigger: {
							trigger: '.js-scroll-wrap04',
							start: "top top",
							end: "+=1000",
							pin: true,
							scrub: true,

							onUpdate: function(self){
								var i = Math.ceil(self.progress * 7) - 1;
								i = i < 0 ? 0 : i;
								$('.js-scroll-target04>div:not(:eq(0))').removeClass('current');
								$('.js-scroll-target04>div:nth-child(-n+'+(i+1)+')').addClass('current');
							},
						}
					}
				);*/


				// グラフ（「いじめ」を検索した前後で検索しているワードは？）
				/*ScrollTrigger.create({
					trigger: '.js-scroll-wrap05',
					start: "top top",
					end: "+=1000",
					pin: true,
					scrub: true,

					onUpdate: function(self){
						var i = Math.ceil(self.progress * 4) - 1;
						i = i < 0 ? 0 : i;
						$('.js-scroll-target05__graph01>div').removeClass('current');
						$('.js-scroll-target05__graph01>div').eq(i).addClass('current');

						$('.js-scroll-target05__text01>ul>li').removeClass('current');
						$('.js-scroll-target05__text01>ul>li').eq(i).addClass('current');
					},
				});*/

			},
		});

	}


	// ページネーション切替計算
	function calcPagenationIndex(width, space, progress){
		var ww = (width + space) * 3;
		var pg = progress * ww;
		var i = 0;
		//console.log(progress * ww);
		//var i = Math.ceil(progress * 4) - 1;
		//i = i < 0 ? 0 : i;
		if(      pg < ((width + space) * 0 + (width / 2))){
			i = 0;
		}else if(pg < ((width + space) * 1 + (width / 2))){
			i = 1;
		}else if(pg < ((width + space) * 2 + (width / 2))){
			i = 2;
		}else{
			i = 3;
		}
		//console.log(i);

		return i;
	}


	//////////////////////////////////////
	// スライダー設定
	var swiper01;

	function setSliders(){

		if($('.js-slider01')[0]){
			var max = $('.js-slider01>.swiper-container>ul>li').length;

			swiper01 = new Swiper('.js-slider01>.swiper-container', {
				speed: 1000,
				allowTouchMove: true,
				spaceBetween: 35,
				slidesPerView: 1,
				slidesPerGroup: 1,

				breakpoints: {
					600:{
						spaceBetween: 50,
					},
				},

				navigation:{
					prevEl: '.js-slider01 .swiper-button-prev',
					nextEl: '.js-slider01 .swiper-button-next',
				},

				pagination:{
					el:'.js-slider01 .swiper-pagination',
					clickable:true,
				},

				on: {
					afterInit: function(){
						var page = this.realIndex + 1;
						setArrows(page);
					},

					slideChange: function(){
						var page = this.realIndex + 1;
						setArrows(page);

						if(page >= max){
							this.params.autoplay = false;
							this.autoplay.stop();
						}

					},
				},
			});

			function setArrows(page){
				if(page <= 1){
					$('.js-slider01 .swiper-button-prev').hide();
				}else{
					$('.js-slider01 .swiper-button-prev').show();
				}

				if(page >= max){
					$('.js-slider01 .swiper-button-next').hide();
				}else{
					$('.js-slider01 .swiper-button-next').show();
				}
			}

		}

	}


	//////////////////////////////////////
	// スマホ：ドラッグ
	function setDragScroll(){
		if(getDevice == 'pc'){
			$('.e-area06__parts01').addClass('for-pc');
			$('.e-area07__parts01').addClass('for-pc');
			$('.e-area06__parts01').mousedragscrollable();
			$('.e-area07__parts01').mousedragscrollable();
		}
	}


	//////////////////////////////////////
	// 追従オブジェクト制御
	function setFloatingObject01(){

		var tg = $('.js-floating01');
		var st = $(window).scrollTop();
		var a_t = tg.parent().offset().top;
		var a_h = tg.parent().outerHeight();
		var t_h = tg.outerHeight();

		if(st <= a_t){
			tg.attr('style', '');
		}else if(st <= (a_t + a_h - t_h)){
			tg.css({'position': 'fixed', 'top': 0});
		}else{
			tg.css({'position': 'absolute', 'top': (a_h - t_h) + 'px'});
		}

	}


	//////////////////////////////////////
	// 追従オブジェクト制御
	function setFloatingObject02(){

		var tg = $('.js-floating02');
		var st = $(window).scrollTop();
		var a_t = tg.parent().offset().top;
		var a_h = tg.parent().outerHeight();
		var t_h = tg.outerHeight();

		if(st <= a_t){
			tg.attr('style', '');
		}else if(st <= (a_t + a_h - t_h)){
			tg.css({'position': 'fixed', 'top': 0});
		}else{
			tg.css({'position': 'absolute', 'top': (a_h - t_h) + 'px'});
		}

	}


	//======================================================//
	// ツール

	//////////////////////////////////////
	// ワイプ
	function setupXxCode(){
		$('.xxObject').wrap('<div class="xxMask"></div>');
	}

	var gsapMp = {
		wipeLeft: function($tgt, $time, $delay, $ease, $comp){
				$('.xxObject', $tgt).css('opacity', 1);
				$('.xxMask'  , $tgt).css('opacity', 1);
				$('.xxObject', $tgt).css({'left': -100+'%'});
				$('.xxMask'  , $tgt).css({'left':  100+'%'});
				gsap.to($('.xxObject', $tgt), {duration: $time, left:0+'%', ease: $ease, delay: $delay});
				gsap.to($('.xxMask'  , $tgt), {duration: $time, left:0+'%', ease: $ease, delay: $delay});
		},
		wipeRight: function($tgt, $time, $delay, $ease,$comp){
				$('.xxObject', $tgt).css('opacity', 1);
				$('.xxMask'  , $tgt).css('opacity', 1);
				$('.xxObject', $tgt).css({'left':  100+'%'});
				$('.xxMask'  , $tgt).css({'left': -100+'%'});
				gsap.to($('.xxObject', $tgt), {duration: $time, left:0+'%', ease: $ease, delay: $delay});
				gsap.to($('.xxMask'  , $tgt), {duration: $time, left:0+'%', ease: $ease, delay: $delay});
		}
	};


	//////////////////////////////////////
	// マウス・ドラッグ・スクロール
	jQuery.prototype.mousedragscrollable = function(){
		let target; // 動かす対象
		$(this).each(function (i, e) {
			$(e).mousedown(function (event) {
				event.preventDefault();
				target = $(e); // 動かす対象
				$(e).data({
					"down": true,
					"move": false,
					"x": event.clientX,
					"y": event.clientY,
					"scrollleft": $(e).scrollLeft(),
					"scrolltop": $(e).scrollTop(),
				});
				return false
			});
			// move後のlink無効
			$(e).click(function (event) {
				if ($(e).data("move")) {
					return false
				}
			});
		});
		// list要素内/外でのevent
		$(document).mousemove(function (event) {
			if ($(target).data("down")) {
				event.preventDefault();
				let move_x = $(target).data("x") - event.clientX;
				let move_y = $(target).data("y") - event.clientY;
				if (move_x !== 0 || move_y !== 0) {
					$(target).data("move", true);
				} else { return; };
				$(target).scrollLeft($(target).data("scrollleft") + move_x);
				$(target).scrollTop($(target).data("scrolltop") + move_y);
				return false
			}
		}).mouseup(function (event) {
			$(target).data("down", false);
			return false;
		});
	}


})();